import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {buildOfferListUrl} from "../../offer/helpers/offer_list_url/build_offer_list_url";
import {ISurveyData} from "../../user/types/IBuildSurveyParams";

interface IListingRegion {
    id: number;
    slug: string;
    type: number;
}

export const getFavouritesEmptyListingUrl = (
    survey: Pick<ISurveyData, "price" | "regions" | "rooms" | "types"> | null | undefined,
    regions: IListingRegion[] = []
): string => {
    const rooms_0 = typeof survey?.rooms?.lower === "number" ? survey.rooms.lower : undefined;
    const rooms_1 = typeof survey?.rooms?.upper === "number" ? survey.rooms.upper : undefined;
    const price_1 = typeof survey?.price?.upper === "number" && survey.price.upper > 0 ? survey.price.upper : undefined;
    const type = survey?.types?.length === 1 ? survey.types[0] : undefined;
    const listingQuery = {
        ...(rooms_0 != null ? {rooms_0} : {}),
        ...(rooms_1 != null ? {rooms_1} : {}),
        ...(price_1 != null ? {price_1} : {}),
        ...(type != null ? {type} : {})
    };

    if (regions.length > 1) {
        return appendQueryString(rpAppLink.offer.multiList(), {
            ...listingQuery,
            region: regions.map((region) => region.id)
        });
    }

    const region = regions[0];

    return buildOfferListUrl({
        ...listingQuery,
        ...(region ? {region: region.slug} : {})
    });
};
import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {buildOfferListUrl} from "../../offer/helpers/offer_list_url/build_offer_list_url";
import {ISurveyData} from "../../user/types/IBuildSurveyParams";

interface IListingRegion {
    id: number;
    slug: string;
    type: number;
}

export const getFavouritesEmptyListingUrl = (
    survey: Pick<ISurveyData, "price" | "regions" | "rooms" | "types"> | null | undefined,
    regions: IListingRegion[] = []
): string => {
    const rooms_0 = typeof survey?.rooms?.lower === "number" ? survey.rooms.lower : undefined;
    const rooms_1 = typeof survey?.rooms?.upper === "number" ? survey.rooms.upper : undefined;
    const price_1 = typeof survey?.price?.upper === "number" && survey.price.upper > 0 ? survey.price.upper : undefined;
    const type = survey?.types?.length === 1 ? survey.types[0] : undefined;
    const listingQuery = {
        ...(rooms_0 != null ? {rooms_0} : {}),
        ...(rooms_1 != null ? {rooms_1} : {}),
        ...(price_1 != null ? {price_1} : {}),
        ...(type != null ? {type} : {})
    };

    if (regions.length > 1) {
        return appendQueryString(rpAppLink.offer.multiList(), {
            ...listingQuery,
            region: regions.map((region) => region.id)
        });
    }

    const region = regions[0];

    return buildOfferListUrl({
        ...listingQuery,
        ...(region ? {region: region.slug} : {})
    });
};
